module.exports = __webpack_public_path__ + "static/media/profilePeding.57a5f5ac.png";